import React, { useCallback, useState } from 'react';
import type { ValueChangedInfo } from 'devextreme/ui/editor/editor';
import { INumberBoxOptions, NumberBox } from 'devextreme-react/number-box';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import type { EditorProps } from './EditorProps';
import { border, borderRadius } from './common';
import Validator, { RequiredRule } from 'devextreme-react/validator';

export interface CurrencyOptions extends INumberBoxOptions {}

export interface CurrencyProps {
  editorType: 'Currency';
  editorOptions: CurrencyOptions;
}

const Currency: React.FC<EditorProps<CurrencyOptions>> = ({
  form,
  dataField,
  isRequired,
  value,
  editorOptions,
}) => {
  editorOptions.readOnly = form.option('readOnly') || editorOptions.readOnly;
  const { readOnly, label } = editorOptions;

  const [currencyValue, setCurrencyValue] = useState(value);
  const onValueChanged = useCallback(
    (change: ValueChangedInfo) => {
      form.updateData(dataField, change.value);
      setCurrencyValue(change.value);
    },
    [dataField, form],
  );
  return (
    <NuvoBox display="flex" flexDirection="row">
      <NuvoBox
        display="flex"
        alignItems="center"
        paddingX={11}
        border={border}
        borderRight="0px"
        borderRadius={`${borderRadius} 0 0 ${borderRadius}`}>
        USD
      </NuvoBox>
      <NuvoBox flex={1}>
        <NumberBox
          readOnly={readOnly}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
          {...editorOptions}
          value={currencyValue as number}
          onValueChanged={onValueChanged}>
          {isRequired && (
            <Validator validationGroup="FormValidationGroup">
              <RequiredRule key={dataField} message={`${label} is required`} />
            </Validator>
          )}
        </NumberBox>
      </NuvoBox>
    </NuvoBox>
  );
};

export default React.memo(Currency);
